import React from "react";

import { Action } from "constants/events";
import { ProductCategory, ProductsByCategory } from "custom-types/Brand";
import { useEventTracker } from "hooks/useEventTracker";

import { ProductsCarousel } from "components/products/ProductsCarousel";

const BrandProductCategories = ({
  brandSlug,
  brandId,
  sortedCategories,
  productsByCategory,
  featureTier,
}: {
  brandSlug: string;
  brandId: number;
  sortedCategories: ProductCategory[];
  productsByCategory: ProductsByCategory;
  featureTier?: string;
}) => {
  const { publishEvent } = useEventTracker();

  return (
    <>
      {sortedCategories.map((category) => (
        <ProductsCarousel
          products={productsByCategory[category.slug]}
          carouselPath={`/brands/${brandSlug}/catalog/${category.slug}`}
          header={
            <h2>
              <span className="heading--m text-md font-extrabold">
                {category.seoName.replace(/./, (m) => m.toUpperCase())}
              </span>
            </h2>
          }
          key={category.slug}
          referringPage="brand"
          seeMoreText={`see all ${category.name.toLowerCase()}`}
          productCardOnClick={() => {
            publishEvent({
              action: Action.click,
              brandId: brandId,
              category: `brand ${featureTier}`,
              label: "products category card",
            });
          }}
          onLoad={() => {
            publishEvent({
              action: Action.impression,
              brandId: brandId,
              category: `brand ${featureTier}`,
              label: `products category - ${category.name?.toLowerCase()}`,
            });
          }}
          seeMoreOnClick={() => {
            publishEvent({
              action: Action.click,
              brandId: brandId,
              category: `brand ${featureTier}`,
              label: `products category link - ${category.name?.toLowerCase()}`,
            });
          }}
        />
      ))}
    </>
  );
};

export default BrandProductCategories;
